<script setup lang="ts">
import SlideBar from '@/components/_common/SlideBar.vue';
import CommonSearch from '@/components/_common/CommonSearch.vue';
import { topBarInsetClass } from '@/components/_common/navbar/topBarInset';

import { computed } from 'vue';
import { useSliderStore } from '@/stores/sliderStore';
const sliderStore = useSliderStore();

const props = defineProps<{
  placeholder: string;
  typeId: string;
}>();

const isTabsOpen = computed({
  get: () => sliderStore.getSliderState(props.typeId, true),
  set: (value) => sliderStore.setSliderState(props.typeId, value),
});
</script>

<template>
  <div :class="topBarInsetClass">
    <SlideBar :is-first-active="isTabsOpen" class="w-full self-stretch">
      <template #first>
        <div class="flex w-full items-center">
          <slot name="tabs" />
          <UIIconButton
            icon="MagnifyingGlassIcon"
            class="ml-auto"
            tooltip="Search"
            @click="isTabsOpen = !isTabsOpen"
          />
        </div>
      </template>
      <template #second>
        <CommonSearch :placeholder="placeholder" @clear="isTabsOpen = true" />
      </template>
    </SlideBar>
  </div>
</template>
